/** Request com os dados para abrir uma revisão das Análises de Mercado */
export class ClienteAnaliseMercadoRevisaoAbrirRequest {
    ano: number;
    idRepresentante: number;

    constructor(ano: number, idRepresentante: number) {
        this.ano = ano;
        this.idRepresentante = idRepresentante;
    }
}
